import { render, staticRenderFns } from "./ElMenuLinks.vue?vue&type=template&id=0c517170"
import script from "./ElMenuLinks.vue?vue&type=script&lang=js"
export * from "./ElMenuLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports